import { render, staticRenderFns } from "./NotifyRider.vue?vue&type=template&id=5dd52ab5&scoped=true"
import script from "./NotifyRider.vue?vue&type=script&lang=js"
export * from "./NotifyRider.vue?vue&type=script&lang=js"
import style0 from "./NotifyRider.vue?vue&type=style&index=0&id=5dd52ab5&prod&lang=scss&scoped=true"
import style1 from "./NotifyRider.vue?vue&type=style&index=1&id=5dd52ab5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd52ab5",
  null
  
)

export default component.exports